module.exports = __webpack_public_path__ + "static/media/exclusive.79842cd3.svg";